import { PlusOutlined, TagOutlined } from '@ant-design/icons'
import './EmptyProductPlaceHolder.style.less'
import { Button } from 'antd'

interface EmptyProductPlaceHolderProps {
  onCreateProduct: () => void
}

function EmptyProductPlaceHolder(props: EmptyProductPlaceHolderProps) {
  return (
    <div className="empty-product-place-holder-container">
      <TagOutlined className="place-holder-icon" />
      <h2>Start by creating a Product</h2>
      <p>Your Product will be displayed here.</p>
      <Button type="primary" onClick={props.onCreateProduct}>
        <PlusOutlined />
        New Product
      </Button>
    </div>
  )
}

export default EmptyProductPlaceHolder
